var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vh-100 d-flex flex-column justify-content-center",
      attrs: { id: "verify-lender-code-page", tabindex: "-1" },
    },
    [
      _c(
        "b-row",
        {
          staticClass: "justify-content-center mb-6",
          staticStyle: { "margin-bottom": "20rem" },
        },
        [
          _c(
            "b-col",
            { attrs: { cols: "11", sm: "10", md: "6", lg: "4", xl: "3" } },
            [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-header card-header-guest-lender-bg px-5",
                  },
                  [
                    _c("div", { staticClass: "header-logos" }, [
                      _c("div", { staticClass: "logo-wrapper" }, [
                        _c("img", {
                          attrs: {
                            width: "100%",
                            height: "auto",
                            src: _vm.$options.filters.getLogo(),
                            alt: "",
                          },
                        }),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card-body p-5" },
                  [
                    _c(
                      "b-row",
                      {
                        staticClass: "justify-content-center",
                        attrs: {
                          id: "verify-lender-code-form",
                          autocomplete: "off",
                          tag: "form",
                        },
                      },
                      [
                        _c(
                          "b-col",
                          { staticClass: "text-center", attrs: { cols: "12" } },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "text-gray mb-4",
                                attrs: { id: "text-header" },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("guest-lender.enterYourCode")
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { id: "pin-container", cols: "12" } },
                          [
                            _c(
                              "b-row",
                              { staticClass: "justify-content-center mb-5" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12", md: "8" } },
                                  [
                                    _c(
                                      "form",
                                      {
                                        on: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [
                                        _c("material-input", {
                                          attrs: {
                                            "class-name": "pin-field",
                                            type: "password",
                                            "on-type": "",
                                            name: "lenderCode",
                                            disabled: _vm.loading,
                                          },
                                          on: { enter: _vm.verifyLenderCode },
                                          model: {
                                            value: _vm.lenderCode,
                                            callback: function ($$v) {
                                              _vm.lenderCode = $$v
                                            },
                                            expression: "lenderCode",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex flex-row justify-content-center",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "simple-button",
                              {
                                staticClass: "verify-pin-submit",
                                attrs: {
                                  id: "verify-lender-code-submit",
                                  "button-type": "submit",
                                  disabled: _vm.$v.$invalid,
                                  loading: _vm.loading,
                                  "loading-succeeded": _vm.codeVerified,
                                },
                                on: { click: _vm.verifyLenderCode },
                              },
                              [
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("global.words.verify")) +
                                      "\n                "
                                  ),
                                ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", { staticClass: "guest-lender-support" }, [
        _c(
          "h6",
          {
            staticClass:
              "text-center text-regular-gray bold font-sm mt-1 mb-0 text-truncate",
          },
          [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.$t("guest-lender.support")) },
            }),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }